const readSubcookie = (cv: string, sck: string): string | undefined =>
  decodeURIComponent((cv.split(/&/).find((sc) => sc.startsWith(`${sck}=`)) || '').slice(sck.length + 1)) || undefined;

export default readSubcookie;
